type PropTypes = {
  className?: string
};

const FilledWarningIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          fillOpacity=".01"
          d="M0 0h14v14H0z"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path fill="currentColor" d="M7 .875C3.631.875.875 3.631.875 7S3.631 13.125 7 13.125 13.125 10.369 13.125 7 10.369.875 7 .875ZM6.519 3.5h.962v4.813H6.52V3.5ZM7 10.938a.673.673 0 0 1-.656-.657c0-.35.306-.656.656-.656.35 0 .656.306.656.656 0 .35-.306.656-.656.656Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FilledWarningIcon
